import { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import { getColor, QueryDropdown } from 'basic-components';
import { DataStorageEnums } from 'dashboard-services/api/dataStorage';

import MetadataLabel from 'primary/MetadataLabel';

const EMPTY_ARRAY = [];
const EMPTY_OBJ = {};

const KeyDropdown = ({ fetchMoreKeys, groupName = undefined, isFetchingKeys, isFetchingNextPageKeys, keyRef = EMPTY_OBJ, keysFromApiRaw = EMPTY_ARRAY, setFilterKey, setFilterKeyType, setKeyQuery, menuPortalTarget = undefined, ...props }) => {
  const onChangeKey = useCallback((value, { data }) => {
          setFilterKey(value)
          setFilterKeyType(data?.type)
        }, [setFilterKey, setFilterKeyType]),
        keysFromApi = useMemo(() => (keysFromApiRaw || []).map(item => ({ 
          value: item.value, 
          label: item.type === DataStorageEnums.KEY_TYPE.METADATA ? (<MetadataLabel name={item.value}/>) : item.value,
          color: item.type === DataStorageEnums.KEY_TYPE.METADATA ? getColor("grey-dark") : undefined,
          type: item.type 
        })), [keysFromApiRaw])

  return (
    <QueryDropdown
        {...props}
        disabled={!groupName}
        fetchNextPage={fetchMoreKeys}
        groupName={groupName}
        isFetching={isFetchingKeys || isFetchingNextPageKeys}
        key={'key'+groupName}
        menuPlacement="bottom"
        menuPortalTarget={menuPortalTarget || document.body}
        name="symbolKey"
        noError
        onChange={onChangeKey}
        onInputChange={setKeyQuery}
        options={keysFromApi}
        placeholder="Choose key"
        ref={keyRef}
        required={false}
        validators={undefined}
    />
  )
}

KeyDropdown.propTypes = {
  fetchMoreKeys: PropTypes.func.isRequired,
  groupName: PropTypes.string,
  isFetchingKeys: PropTypes.bool.isRequired,
  isFetchingNextPageKeys: PropTypes.bool.isRequired,
  keyRef: PropTypes.any,
  keysFromApiRaw: PropTypes.array,
  menuPortalTarget: PropTypes.any,
  setFilterKey: PropTypes.func.isRequired,
  setFilterKeyType: PropTypes.func.isRequired,
  setKeyQuery: PropTypes.func.isRequired,
}

export default KeyDropdown;